import API from "@/services/api";
import { 
  FetchCUPSAvailabilityData,
  FetchCUPSAvailabilityParams,
  FetchElecSIPSCUPSAvailabilityResponse,
  FetchGasCUPSAvailabilityData,
  FetchGasSIPSCUPSAvailabilityResponse
} from "../types/cups";

export enum Endpoints {
  CUPSConfig = "/contractacio/config/cups/:cups",
  GasCUPSConfig = "/gas/contractacio/config/cups/:cups"
}

const validateElectricityCUPSAvailability = (
  cups: FetchCUPSAvailabilityParams['cups']
) => {
  return new Promise<FetchCUPSAvailabilityData>(async (resolve, reject) => {
    API.get<FetchElecSIPSCUPSAvailabilityResponse>({
      endpoint: Endpoints.CUPSConfig,
      params: {
        cups
      },
      versions: [1]
    })
    .then(({promise: { data }}) => {
      resolve({
        cupsAvailable: data.elegible,
        ...data.data?.status == "ok" ? {
          sipsDataAvailable: true,
          accessTariff: data.data.sips_data.access_tariff.id,
          accessTariffName:  data.data.sips_data.access_tariff.name,
          address: {
            zipcode: data.data.sips_data.address.zipcode,
          },
          power: data.data.sips_data.powers.p1,
          power2: data.data.sips_data.powers.p2,
          power3: data.data.sips_data.powers.p3,
          power4: data.data.sips_data.powers.p4,
          power5: data.data.sips_data.powers.p5,
          power6: data.data.sips_data.powers.p6,
          selfcons: data.data.sips_data.selfcons,
          selfconsCode: data.data.sips_data.autoconsumo_code,
        } : {
          sipsDataAvailable: false,
          accessTariff: null,
          accessTariffName:  "",
          address: {
            zipcode: "",
          },
          power: null,
          power2: null,
          power3: undefined,
          power4: undefined,
          power5: undefined,
          power6: undefined,
          selfcons: false,
          selfconsCode: "00"
        },
      })
    })
    .catch(err => {
      reject(err);
    })
  })
} 

const validateGasCUPSAvailability = (
  cups: FetchCUPSAvailabilityParams['cups']
) => {
  return new Promise<FetchGasCUPSAvailabilityData>(async (resolve, reject) => {
    API.get<FetchGasSIPSCUPSAvailabilityResponse>({
      endpoint: Endpoints.GasCUPSConfig,
      params: {
        cups
      },
      versions: [2]
    })
    .then(({promise: { data }}) => {
      resolve({
        cupsAvailable: data.elegible,
        ...data.data?.status == "ok" ? {
          sipsDataAvailable: true,
          accessTariff: data.data.sips_data.access_tariff.id,
          accessTariffName:  data.data.sips_data.access_tariff.name,
          address: {
            zipcode: data.data.sips_data.address.zipcode,
          }
        } : {
          sipsDataAvailable: false,
          accessTariff: null,
          accessTariffName:  "",
          address: {
            zipcode: "",
          }
        }
      })
    })
    .catch(err => {
      reject(err);
    })
  })
}

export default {
  validateElectricityCUPSAvailability,
  validateGasCUPSAvailability
};


